import { SCREEN_ID_ENUM, ANDROID_LOCAL_FILE_KEY } from '@/constants';
import { apiGetScreenLayoutMediaAsset } from '@/api/layouts';
import { getCloudfrontUrl } from '@/helpers/utils';
import { logger } from '@/utils/screenEventsLogger';

export function getAndroidVideoItemKey(itemId) {
  return `${ANDROID_LOCAL_FILE_KEY}-${itemId}`;
}

function isAlreadyDownloaded(itemId) {
  return !!window[getAndroidVideoItemKey(itemId)];
}

export async function downloadVideosForAndroid() {
  return new Promise((resolve, reject) => {
    const screenId = localStorage.getItem(SCREEN_ID_ENUM);
    apiGetScreenLayoutMediaAsset(screenId)
      .then((data) => {
        const filesToDownload = data.mediaAssets
          .filter((asset) => asset.fontName === null && asset.itemType === 'video/mp4')
          .reduce((acc, asset) => {
            if (isAlreadyDownloaded(asset.itemId)) return acc;
            acc[asset.itemId] = getCloudfrontUrl(asset.itemUrl);
            return acc;
          }, {});

        const successCb = (result) => {
          logger.addLog('Android Videos Downloaded successfully');
          const downloadedFiles = result.files;
          Object.keys(downloadedFiles).forEach((fileKey) => {
            window[getAndroidVideoItemKey(fileKey)] = downloadedFiles[fileKey];
          });
          resolve(result);
        };
        const failureCb = (error) => {
          logger.addLog('Error: Android Videos Download');
          reject(error);
        };
        window.updateProgress = (progress) => {
          logger.addLog('Progress: Android Videos Download');
        };

        window.finishDownload = (res) => {
          let result = JSON.parse(res);
          if (result.error) {
            failureCb(result.error);
          } else {
            successCb(result);
          }
        };

        // Request download files on android
        if (window.downloadFiles) window.downloadFiles(filesToDownload);
      })
      .catch(reject);
  });
}
